import React, { useContext, useEffect, useState } from "react";
import ParticlesAuth from "./ParticlesAuth";
import { Alert, Button, Card, CardBody, Col, Container, Form, Input, Label, NavLink, Row, Spinner } from "reactstrap";
import {UserLogin} from "../../../Actions/UserActs";
import { GlobalStore } from "../../../StateStores";
import { useNavigate } from "react-router-dom";


const Login = ()=>{
    const [passwordShow, setPasswordShow] = useState(false);
    const [form,setForm] = useState({});
    const [formErrors,setFormErrors] = useState({
        email:'Email is required',
        password:'Password is required',
    });
    const {authDispatch,authState:{error,loading}} = useContext(GlobalStore);
    const [formValid, setFormValid] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        // Check if there are any errors in the form
        const isValid = Object.values(formErrors).every(item => !item);
        setFormValid(isValid);
    }, [formErrors]);

    const onChange = ({name,e})=>{
        let value = e.target.value;
        setForm({...form,[name]:value});

        if(value !== ''){

            setFormErrors((prev) => {
            return {...prev, [name]: null};
            });

        }else{

            setFormErrors((prev) => {
                return {...prev, [name]: 'This field is required'};
            });

        }

    }

    const handleSubmit = (e)=>{
        e.preventDefault();

        if(formValid){
            UserLogin(form)(authDispatch)
        }
    }

    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-page-content">
                
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 mb-4 text-white-50">
                                    <div>
                                        <img src="/corporationsolo.png" alt="" height="100" />
                                    </div>
                                    <p className="mt-3 fs-15 fw-medium">Corporation Sole Management Information Tool (CSMIT)</p>
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="">
                                    <CardBody className="p-4">

                                        {error?.status === 'Failed' && (

                                            <Alert color="danger">
                                                <strong>{error?.message}</strong>
                                            </Alert>

                                        )}
                                    
                                        <div className="text-center">
                                            <h5 className="text-primary">Welcome Back !</h5>
                                            <p className="text-muted">Enter your email & password to login</p>
                                        </div>

                                        <Form onSubmit={handleSubmit}>
                                            <div className="">
                                                <div className="mb-3">
                                                    <Label htmlFor="email" className="form-label">E-mail</Label>
                                                    <Input
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="Enter email"
                                                        type="text"
                                                        onChange={(e) => onChange({name:'email',e})}
                                                        valid={formErrors.email === null}
                                                        invalid={formErrors.email !== null}
                                                    />
                                                    <small>{formErrors.email}</small>
                                                </div>

                                                <div className="mb-3">
                                                    <div className="float-end">
                                                        <NavLink to="/forgot-password" className="text-muted">Forgot password?</NavLink>
                                                    </div>
                                                    <Label className="form-label" htmlFor="password-input">Password</Label>
                                                    <div className="position-relative auth-pass-inputgroup mb-3">
                                                        <Input
                                                            name="password"
                                                            type={passwordShow ? "text" : "password"}
                                                            className="form-control pe-5"
                                                            placeholder="Enter Password"
                                                            onChange={(e) => onChange({name:'password',e})}
                                                            valid={formErrors.password === null}
                                                            invalid={formErrors.password !== null}
                                                        />
                                                        <button 
                                                            className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" 
                                                            type="button"
                                                            onClick={() => setPasswordShow(!passwordShow)}><i className="ri-eye-fill align-middle"></i>
                                                        </button>
                                                    </div>
                                                    <small>{formErrors.password}</small>
                                                </div>

                                                {/* <div className="form-check">
                                                    <Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                                                    <Label className="form-check-label" htmlFor="auth-remember-check">Remember me</Label>
                                                </div> */}
                                                <div className="mt-4">
                                                    <Button
                                                        color="secondary"  
                                                        disabled={!formValid}
                                                        className="w-100" type="submit">
                                                        {loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : null}
                                                        Sign In
                                                    </Button>
                                                </div>
                                            </div>
                                        </Form>
                                    </CardBody>
                                </Card>

                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    )
    
}

export default Login;